import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import AnchorRoundedIcon from "@mui/icons-material/AnchorRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import DirectionsBoatRoundedIcon from "@mui/icons-material/DirectionsBoatRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const serviceTypes = [
  { id: "domestic", label: "Domestic", Icon: LocalShippingRoundedIcon },
  { id: "import", label: "Import", Icon: AnchorRoundedIcon },
  { id: "export", label: "Export", Icon: Inventory2OutlinedIcon },
  { id: "empty-container", label: "Empty Container", Icon: Inventory2OutlinedIcon },
  { id: "roro-odc", label: "RORO / ODC", Icon: DirectionsBoatRoundedIcon }
];

export default function QuickBooking() {
  const navigate = useNavigate();
  const [serviceType, setServiceType] = useState("domestic");
  const [pickup, setPickup] = useState("");
  const [delivery, setDelivery] = useState("");
  const [cargoType, setCargoType] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("/addbookings", {
      state: {
        landingQuickQuote: { serviceType, pickup, delivery, cargoType }
      }
    });
  };

  return (
    <section className="pl-quick-wrap" aria-label="Quick shipment quote">
      <div className="pl-container">
        <form className="pl-quick" id="quick-quote" onSubmit={handleSubmit}>
          <div className="pl-quick__tabs" role="tablist" aria-label="Shipment type">
            {serviceTypes.map(({ id, label, Icon }) => (
              <button
                key={id}
                type="button"
                role="tab"
                aria-selected={serviceType === id}
                className={serviceType === id ? "is-active" : ""}
                onClick={() => setServiceType(id)}
              >
                <Icon aria-hidden="true" />
                {label}
              </button>
            ))}
          </div>

          <div className="pl-quick__fields">
            <label className="pl-field">
              <LocationOnRoundedIcon aria-hidden="true" />
              <span>
                <b>Pickup Location</b>
                <input
                  type="text"
                  value={pickup}
                  onChange={(event) => setPickup(event.target.value)}
                  placeholder="Enter pickup address"
                  aria-label="Pickup location"
                />
              </span>
            </label>
            <SwapHorizRoundedIcon className="pl-quick__swap" aria-hidden="true" />
            <label className="pl-field">
              <LocationOnRoundedIcon aria-hidden="true" />
              <span>
                <b>Delivery Location</b>
                <input
                  type="text"
                  value={delivery}
                  onChange={(event) => setDelivery(event.target.value)}
                  placeholder="Enter delivery address"
                  aria-label="Delivery location"
                />
              </span>
            </label>
            <label className="pl-field">
              <Inventory2OutlinedIcon aria-hidden="true" />
              <span>
                <b>Cargo Type</b>
                <select value={cargoType} onChange={(event) => setCargoType(event.target.value)} aria-label="Cargo type">
                  <option value="">Select cargo type</option>
                  <option value="general">General cargo</option>
                  <option value="container">Container</option>
                  <option value="oversized">Oversized cargo</option>
                  <option value="vehicle">Vehicle / RORO</option>
                </select>
              </span>
            </label>
            <button className="pl-button pl-button--primary pl-quick__submit" type="submit">
              <SearchRoundedIcon aria-hidden="true" />
              Get Quote
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
